import { replaceErrorAvatar } from "@helpers";
import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/MainSidebar.module.css";

const SubscriptionItem = (props) => {
  const {
    avatarUrl,
    fullName,
    id,
    isOnline = false,
    showTitle = true,
    onAfterClick,
  } = props;
  let classNameActive = isOnline ? styles.subscriptionActive : "";

  return (
    <Link
      className={styles.sidebarItem}
      to={`instructor-profile-view/${id}`}
      onClick={onAfterClick}
    >
      <div style={{ width: "60px", display: "flex", justifyContent: "center" }}>
        <img
          src={avatarUrl}
          alt="avatar"
          className={styles.subscriptionAvatar}
          onError={replaceErrorAvatar}
        />
      </div>
      {showTitle && (
        <div className="flex-grow-1 d-flex align-items-center justify-content-between">
          <p className={styles.subscriptionName}>{fullName}</p>
          <div className={`mr-3 ${classNameActive}`}></div>
        </div>
      )}
    </Link>
  );
};

/* required: display name */
SubscriptionItem.displayName = "SubscriptionItem";

/* required: props types */
SubscriptionItem.propTypes = {};

/* required: default props */
SubscriptionItem.defaultProps = {};

export { SubscriptionItem };
